import React from "react";

export default function Story() {
  return (
    <div className="w-full flex justify-around items-start flex-wrap z-50 sm:gap-0 gap-10">
      <div className="w-full flex opacity-90 justify-start items-start sm:ml-40 sm:mt-32">
        <div
          data-aos="fade-down"
          data-aos-delay="2000"
          data-aos-duration="500"
          data-aos-easing="ease-in-out"
          className=" h-fit lg:w-2/4 flex justify-center items-center p-10 text-neutral-100"
        >
          <p className="sm:text-xl text-sm font-light tracking-wide leading-loose text-justify">
            Over the past decade, Amadeus’s journey has been
            nothing short of extraordinary. Since founding
            his business in 2014, he has had the privilege
            of collaborating with countless beauty icons,
            celebrities, and influencers, creating a vibrant
            tapestry of artistry and innovation. His
            commitment to excellence has been recognized
            through numerous awards, including the
            prestigious "Beauty Golden Award" in 2017 for
            the youngest entrepreneur and successful
            business model. Amadeus proudly made part of the
            Schwarzkopf Global Color Crafter in Hamburg and
            Berlin, further establishing his presence on the
            international stage.
          </p>
        </div>
      </div>
      <div className="w-full flex sm:justify-end justify-center items-center">
        <div
          data-aos="fade-up"
          data-aos-delay="2200"
          data-aos-duration="1000"
          data-aos-easing="ease-in-out"
          className="lg:w-1/3 w-full h-full align-end sm:-mt-20"
        >
          <img
            src="./amadeus-1.png"
            className="size-96"
            alt="story"
          />
        </div>
      </div>
    </div>
  );
}
